import {hospitalTypes} from "../types/hospitalTypes";

const initState = {
    hospital: null,
    currentHospitalNotFound: false,
    hospitalIsLoading: true,
    hospitalDoctors: [],
    hospitalDoctorsIsLoading: true,
    aboutHospitalIsLoading: true,
    currentHospitalDoctorsSearchData: null,
    showMoreHospitalDoctorsLoading: false,
    noMoreHospitalDoctors: false,
};

const hospitalReducer = (state = initState, action) => {
    switch (action.type) {
        case hospitalTypes.GET_HOSPITAL_PROFILE:
            state = {
                ...state,
                hospital: action.payload,
                hospitalIsLoading: false,
                aboutHospitalIsLoading: false,
            };
            break;
        case hospitalTypes.CURRENT_HOSPITAL_NOT_FOUND:
            state = {
                ...state,
                currentHospitalNotFound: true,
            };
            break;
        case hospitalTypes.GET_HOSPITAL_DOCTORS:
            state = {
                ...state,
                hospitalDoctors: [...state.hospitalDoctors, ...action.payload],
                hospitalDoctorsIsLoading: false,
                noMoreHospitalDoctors: false,
                showMoreHospitalDoctorsLoading: false,
            };
            break;
        case hospitalTypes.FETCHING_MORE_HOSPITAL_DOCTORS:
            state = {
                ...state,
                showMoreHospitalDoctorsLoading: action.payload
            };
            break;
        case hospitalTypes.NO_MORE_HOSPITAL_DOCTORS:
            state = {
                ...state,
                noMoreHospitalDoctors: action.payload,
            };
            break;
        case hospitalTypes.CLEAR_HOSPITAL_PROFILE:
            state = {
                ...state,
                aboutHospitalIsLoading: true,
            };
            break;
        case hospitalTypes.SET_HOSPITAL_DOCTORS_SEARCH_DATA:
            state = {
                ...state,
                currentHospitalDoctorsSearchData: action.payload
            };
            break;
        case hospitalTypes.CLEAR_HOSPITAL_DOCTORS_SEARCH_DATA:
            state = {
                ...state,
                currentHospitalDoctorsSearchData: null
            };
            break;
        case hospitalTypes.CLEAR_HOSPITAL_DOCTORS_LIST:
            state = {
                ...state,
                hospitalDoctors: [],
                hospitalDoctorsIsLoading: true,
            };
            break;

        default :
        // do nothing
    }
    return state
};


export default hospitalReducer